import { requestToCMS } from './requestToCMS';
import { Endpoint, getStrapiEndpoint } from '../../constants';

/**
 * Configuration for the delete request made to the CMS.
 */
type DeleteConfig = {
    /*
     The endpoint to make the request to
     */
    endpoint: Endpoint;
    /*
    The id of the entity that should be deleted.
     */
    id: string;
    /*
    The token to use in the request. Either the user token for logged in/user specific actions or our API token for general requests.
     */
    jwt: string;
};

const deleteFromCMS = async <T = null, E = any>(config: DeleteConfig) => {
    const requestUrl = `${getStrapiEndpoint(config.endpoint)}/${config.id}`;
    const response = await requestToCMS<T, E>({
        url: requestUrl,
        method: 'DELETE',
        accessToken: config.jwt
    });

    return !response.error
        ? { success: true }
        : {
              success: false,
              error: response.error
          };
};

export { deleteFromCMS };
